import $ from 'jquery';

const defaults = {
    toggleClass: 'c-timeline-item-is-open',
    listElement: '.c-timeline-item',
    hiddenContent: '.c-timeline-hidden-content'
};

let buttons = undefined;
let buttonItems = undefined;
const toggleClass = (item) => {
    if ($(item).parents(defaults.listElement).hasClass(defaults.toggleClass)) {
        $(item).parents(defaults.listElement).removeClass(defaults.toggleClass);
        $(item).attr('aria-expanded', false);
        $(item).next().find(defaults.hiddenContent).attr('aria-hidden', true);
    } else {
        $(item).parents(defaults.listElement).addClass(defaults.toggleClass);
        $(item).attr('aria-expanded', true);
        $(item).next().find(defaults.hiddenContent).attr('aria-hidden', false);
    }
};

function init(buttonsElm) {
    buttons = buttonsElm;
    buttonItems = [].slice.call(buttons);

    // add event listener
    buttonItems.forEach(function (item) {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            toggleClass(item);
        });
    });
}

export default {
    init
};
